module.exports = __webpack_public_path__ + "static/media/01-dr-default.16133e71.png";